module.exports = __webpack_public_path__ + "static/assets/07cde53e4081efae25eaa9518ddc0f32.png";